export const isUnacknowledgedSuite = (order = {}) => {
  const courseNumber = Number(order?.courseNumber ?? order?.course_number ?? 1);
  if (courseNumber <= 1) return false;
  const status = String(order?.status || "").toLowerCase();
  if (!["pending", "confirmed"].includes(status)) return false;
  return !(order?.items || []).some((item) =>
    ["preparing", "ready", "served"].includes(
      String(item?.status || "").toLowerCase(),
    ),
  );
};

export const compareKdsOrders = (left = {}, right = {}, orderPriority = {}) => {
  if (Boolean(left.urgent) !== Boolean(right.urgent))
    return left.urgent ? -1 : 1;
  const leftSuite = isUnacknowledgedSuite(left);
  const rightSuite = isUnacknowledgedSuite(right);
  if (leftSuite !== rightSuite) return leftSuite ? -1 : 1;
  const leftTime = new Date(left.timestamp || left.created_at || 0).getTime();
  const rightTime = new Date(
    right.timestamp || right.created_at || 0,
  ).getTime();
  if (leftTime !== rightTime) return leftTime - rightTime;
  return (
    (orderPriority[left.status] || 99) - (orderPriority[right.status] || 99)
  );
};

export const sortKdsOrdersByPriority = (orders = [], orderPriority = {}) =>
  [...orders].sort((left, right) =>
    compareKdsOrders(left, right, orderPriority),
  );

export const partitionKdsOrdersByReadiness = (orders = []) => {
  const source = Array.isArray(orders) ? orders : [];
  const upcomingByOrder = new Map();
  source.forEach((order) => {
    if (String(order?.status || "").toLowerCase() !== "held") return;
    const key = String(order?.orderId || "");
    if (!key) return;
    const current = upcomingByOrder.get(key) || {
      itemCount: 0,
      courseNumbers: new Set(),
    };
    current.itemCount += (order.items || []).reduce(
      (sum, item) => sum + Math.max(1, Number(item?.quantity) || 1),
      0,
    );
    current.courseNumbers.add(Number(order.courseNumber) || 1);
    upcomingByOrder.set(key, current);
  });

  const enriched = source.map((order) => {
    const upcoming = upcomingByOrder.get(String(order?.orderId || ""));
    return upcoming
      ? {
          ...order,
          upcomingItemCount: upcoming.itemCount,
          upcomingCourseCount: upcoming.courseNumbers.size,
        }
      : order;
  });
  const isHeld = (order) =>
    String(order?.status || "").toLowerCase() === "held";

  return {
    productionOrders: enriched.filter((order) => !isHeld(order)),
    upcomingCourses: enriched.filter(isHeld),
    rhodeAnnouncementOrders: enriched.filter(
      (order) =>
        !isHeld(order) ||
        String(order?.dispatchKind || "").toLowerCase() === "addition",
    ),
  };
};

export const buildKdsGroupKey = (row = {}, displayNumber = "") => {
  const orderIdentity =
    Number(row?.order_id) ||
    String(row?.order_number || displayNumber || row?.id || "unknown");
  const courseIdentity = Number(row?.course_id)
    ? `course-${Number(row.course_id)}`
    : "legacy";
  const dispatchKind = String(row?.dispatch_kind || "").toLowerCase();
  const dispatchIdentity =
    ["claim", "addition"].includes(dispatchKind) &&
    Number(row?.dispatch_event_id) > 0
      ? `::dispatch-${Number(row.dispatch_event_id)}`
      : "";
  return `${orderIdentity}::${courseIdentity}${dispatchIdentity}`;
};
